import {Component, OnInit} from '@angular/core';
import {DatePipe, NgIf} from "@angular/common";
import {MatCard, MatCardContent} from "@angular/material/card";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {catchError, finalize, of, tap} from "rxjs";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {NgxSpinnerService} from "ngx-spinner";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {DialogService} from "../../../_modal/dialog.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {HttpClient} from "@angular/common/http";
import {CommonResponse} from "../../../_models/Response";

@Component({
    selector: 'app-clients-terrain-details',
    providers: [Endpoints, DialogService, ClientsService, HttpClient],
    standalone: true,
    imports: [
        DatePipe,
        MatCard,
        MatCardContent,
        RouterOutlet,
        NgIf
    ],
    templateUrl: './clients-terrain-details.component.html',
    styleUrl: './clients-terrain-details.component.scss'
})
export class ClientsTerrainDetailsComponent implements OnInit {
    clientId: string;
    clientTerrain: any[];

    constructor(
        private route: ActivatedRoute,
        private apiService: ApiService,
        private http: HttpClient,
        private endpoints: Endpoints,
        public themeService: CustomizerSettingsService,
    ) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.clientId = params.get('id') || '';
            if (this.clientId) {
                this.fetchClientDetails(this.clientId);
            }
        });
    }

    fetchClientDetails(clientId: string) {

        const terrain_url: string = this.endpoints.client_terrain_base_endpoint + `/getByClientId/${clientId}`;
        console.log(terrain_url)

        this.http.get<CommonResponse>(terrain_url).subscribe({ 
            next: response => {
                      console.log('📥 Réponse du backend :', response); // ✅ Console ajoutée ici

                if (response.status) {
                    this.clientTerrain = response.data;
                }
            }

        })
    }
}
